import { differenceInCalendarDays } from 'date-fns';
import { getDateWithoutTimezone } from '@ibk/shared-utils';
export var EmissorOrderScreenStatus;
(function (EmissorOrderScreenStatus) {
    EmissorOrderScreenStatus["GENERATING_BILLING"] = "GENERATING_BILLING";
    EmissorOrderScreenStatus["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    EmissorOrderScreenStatus["RELEASING_CREDIT"] = "RELEASING_CREDIT";
    EmissorOrderScreenStatus["CREDIT_RELEASED"] = "CREDIT_RELEASED";
    EmissorOrderScreenStatus["CANCELLED"] = "CANCELLED";
})(EmissorOrderScreenStatus || (EmissorOrderScreenStatus = {}));
export const EMISSOR_ORDER_STATUS_LABELS = {
    [EmissorOrderScreenStatus.GENERATING_BILLING]: 'benefits.orders.status.generating-billing',
    [EmissorOrderScreenStatus.PENDING_PAYMENT]: 'benefits.orders.status.pending-payment',
    [EmissorOrderScreenStatus.RELEASING_CREDIT]: 'benefits.orders.status.releasing-credit',
    [EmissorOrderScreenStatus.CREDIT_RELEASED]: 'benefits.orders.status.credit-released',
    [EmissorOrderScreenStatus.CANCELLED]: 'benefits.orders.status.cancelled',
};
const PAYABLE_SCREEN_STATUSES = new Set([
    EmissorOrderScreenStatus.GENERATING_BILLING,
    EmissorOrderScreenStatus.PENDING_PAYMENT,
]);
export function isOrderPayable(screenStatus) {
    return PAYABLE_SCREEN_STATUSES.has(screenStatus);
}
const MIN_EDITABLE_DAYS_AHEAD = 1;
export function isCreditDateEditable(order, today = new Date()) {
    if (order.screenStatus === EmissorOrderScreenStatus.PENDING_PAYMENT) {
        return true;
    }
    if (order.screenStatus === EmissorOrderScreenStatus.RELEASING_CREDIT && order.scheduledCreditDate) {
        const scheduledDate = getDateWithoutTimezone(order.scheduledCreditDate);
        return differenceInCalendarDays(scheduledDate, today) >= MIN_EDITABLE_DAYS_AHEAD;
    }
    return false;
}
export function isDetailsPaymentActionVisible(screenStatus) {
    return isOrderPayable(screenStatus);
}
const CANCELLABLE_SCREEN_STATUSES = new Set([
    EmissorOrderScreenStatus.GENERATING_BILLING,
    EmissorOrderScreenStatus.PENDING_PAYMENT,
]);
export function isOrderCancellable(screenStatus) {
    return CANCELLABLE_SCREEN_STATUSES.has(screenStatus);
}
